<template>
  <div class="app-container" :style="cornerImage">
    <div class="top-bar">
      <div style="padding: 15px 0px 15px 10px">
        <img src='../assets/home-black-24px.svg' style="width: 24px; height: 24px; display: block; 
        margin: auto;" @click="goToExternalPortal()">
      </div>
      <div></div>
      <div>
        <h5 class="username-text">
          {{ this.supplierCode + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + this.supplier.rfc }}{{ '\xa0\xa0\xa0' }}</h5>
        <img src='../assets/account_circle-24px.svg' class="top-bar-icon">
      </div>
    </div>
    <v-navigation-drawer persistent :mini-variant="miniVariant" :clipped="clipped" v-model="drawers.root" fixed
      :temporary="temporary" permanent app class="root-menu menus">
      <v-toolbar flat class="py-3" style="background: var(--v-menuBackground-base); z-index: 1;" @click="goToHome()">
        <v-spacer></v-spacer>
        <img src="@/assets/logo.svg" width="110px">
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-list class="pa-0 fill-space">
        <v-list-tile value="true" v-for="(item, i) in items" :key="i" @click="menuItem(item)" class="border-bottom"
          v-bind:class="{ 'menu-selected': selectedMenus.root == item || (!!selectedMenus.currentRoute && selectedMenus.currentRoute == item.route) }">
          <v-list-tile-action>
            <v-badge right color="info" v-model="item.showBadge">
              <span slot="badge" v-if="!!item.showBadge && !!item.badge.number">{{ displayBadge(item.badge.number) }}</span>
              <v-icon v-if="item.icon" v-html="item.icon"></v-icon>
              <div class="svg-icon" v-if="item.svg" v-html="icons[item.svg]"></div>
            </v-badge>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="item.subMenus && item.subMenus.length">
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-list class="pa-0">
        <v-list-tile class="border-top" @click="changeLanguage()">
          <v-list-tile-action class="icon-space">
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="icon-text">
            <v-list-tile-title>{{ this.$t('message.toggleLanguageText') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="border-top" @click="closeSesion()">
          <v-list-tile-action class="icon-space">
            <v-icon class="close-session-icon">get_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="icon-text">
            <v-list-tile-title>{{ this.$t('message.menuSignOut') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content v-bind:class="{ 'root-drawer-active': drawers.root, 'second-drawer-active': drawers.second }">
      <router-view :key="routerViewKey" />
    </v-content>
  </div>
</template>

<style>
.top-bar {
  background-color: white;
  box-shadow: 0px 2px 2px gray;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 8px;
  border-radius: 5px;
  margin-bottom: 20px;
  margin-top: 10px;
  height: 40px;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)
}

.top-bar-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin: 15px 10px 15px 0px;
}

.username-text {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  font-family: Roboto;
  font-weight: 600;
  font-size: 15px;
}

.v-badge>span {
  width: 18px;
  height: 18px;
  top: -8px;
  right: -10px;
}
</style>

<style scoped>
.v-toolbar {
  cursor: pointer;
}

/* sidebar */
.root-menu.menus {
  display: flex;
  flex-direction: column;
  background-color: var(--v-menuBackground-base);
  border-radius: 60px 20px 20px 60px;
  margin: 10px 10px 10px 10px !important;
  width: 210px !important;
  max-height: calc(100% - 20px) !important;
}

/* Title */

.v-list__tile__title {
  line-height: 20px;
}

/* Icon */
.v-list__tile__action {
  min-width: 35px;
}

.root-menu.menus .fill-space {
  flex-grow: 1;
  margin-bottom: -1px;
}

.app-container {
  padding: 0px 25px 0px 230px;
}

.menus {
  color: var(--v-menuText-base);
}

.menus .theme--light.v-list {
  background-color: transparent;
  background: none;
  color: var(--v-menuText-base);
}

/* sidebar buttons */
.menus>>>.v-list__tile {
  color: var(--v-menuText-base) !important;
  caret-color: var(--v-menuText-base) !important;
  border-radius: 35px;
  font-size: 18px;
  margin: 15px 13px;
  padding: 14px 12px 14px 12px;
}

.v-list__tile__action .v-icon {
  width: 20px;
  height: 20px;
}

.menus .v-list * {
  color: inherit;
}

.menus .menu-selected>>>.v-list__tile {
  background-color: var(--v-menuSelectedItem-base);
  color: var(--v-menuSelectedText-base) !important;
  caret-color: var(--v-menuSelectedText-base) !important;
}

.menus>>>.v-list__tile:hover {
  background-color: var(--v-menuSelectedItem-base) !important;
  color: var(--v-menuSelectedText-base) !important;
  caret-color: var(--v-menuSelectedText-base) !important;
}

.menus>>>.v-list__group__items {
  background-color: var(--v-menuBackground-darken1);
}

.menus>>>.v-list__group__header__append-icon i {
  color: var(--v-menuText-base)
}

/* SVG icon styles */
.svg-icon,
.svg-icon>>>svg {
  height: 24px !important;
}

.menus>>>.v-list__tile path {
  fill: var(--v-menuText-base) !important;
}

.menus>>>.v-list__tile:hover path,
.menus .menu-selected>>>.v-list__tile path {
  fill: var(--v-menuSelectedText-base) !important;
}

.close-session-icon {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.root-menu:not(.v-navigation-drawer--temporary) {
  z-index: 4;
}

.root-drawer-active {
  /* Variable */
  padding-left: 0px !important;
}

.second-drawer-active {
  /* Variable */
  padding-left: 600px !important;
}
</style>

<script>

import { events } from '../main';
import { i18n } from '../utils/locales/default';

export default {
  name: 'core',
  data() {
    return {
      icons: {},
      cornerImage: {
        'background-position-x': '100%',
        'min-height': '832px',
      },
      supplier: {},
      supplierCode: "",
      clipped: true,
      drawers: {
        root: true,
        second: false,
      },
      fixed: true,
      temporary: false,
      items: null,
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: 'Whirlpool - Portal de Proveedores',
      badgeIntervals: [],
      selectedMenus: {
        root: undefined,
        second: undefined,
        third: undefined,
        currentRoute: undefined
      },
      menusStoreStates: {
        root: false,
        second: false
      },
      routerViewKey: 0,
    }
  },
  methods: {
    snackbar: function (message) {
      events.$emit('snackbar', message);
    },
    changeLanguage() {
      if (i18n.locale == "en") {
        this.$set(i18n, 'locale', "es");
      } else {
        this.$set(i18n, 'locale', "en");
      }
      this.updateMenuLanguage();
      events.$emit('updateLanguage');
    },
    updateMenuLanguage() {
      this.items = [
        {
          icon: 'track_changes',
          title: this.$t('message.menuTracking'),
          route: 'Seguimientolist',
          entityName: '',
          level: 1,
        },
        {
          icon: 'widgets',
          title: this.$t('message.menuNewUpload'),
          route: 'fileLoader',
          entityName: '',
          level: 1,
        }
      ];
    },
    checkMenusSelected() {
      this.selectedMenus.currentRoute = this.$route.name;
      this.items.forEach(rootMenuElement => {
        if (rootMenuElement.subMenus) {
          rootMenuElement.subMenus.forEach(secondMenuElement => {
            if (secondMenuElement.subMenus) {
              secondMenuElement.subMenus.forEach(thirdMenuElement => {
                if (thirdMenuElement.route == this.selectedMenus.currentRoute) {
                  //Force Open TODO
                  this.selectedMenus.third = thirdMenuElement;
                  this.selectedMenus.second = secondMenuElement;
                  this.selectedMenus.root = rootMenuElement;
                  secondMenuElement.open = true;
                  this.drawers.second = true;
                  this.drawers.root = true;
                }
              });
            } else {
              if (secondMenuElement.route == this.selectedMenus.currentRoute) {
                this.selectedMenus.second = secondMenuElement;
                this.selectedMenus.root = rootMenuElement;
                this.drawers.second = true;
              }
            }
          })
        } else {
          if (rootMenuElement.route == this.selectedMenus.currentRoute) {
            this.selectedMenus.root = rootMenuElement;
            this.drawers.root = true;
          }
        }
      })
    },
    openCloseMenu() {
      if (this.drawers.root) {
        this.menusStoreStates.root = this.drawers.root;
        this.menusStoreStates.second = this.drawers.second;
        this.drawers.root = false;
        this.drawers.second = false;
      } else {
        this.drawers.second = this.menusStoreStates.second;
        this.drawers.root = true;
      }
    },
    menuItem(item) {
      //Set Selected Item
      if (item.level == 1) {
        this.selectedMenus.root = item;
        this.selectedMenus.second = undefined;
        this.selectedMenus.third = undefined;
      } else if (item.level == 2) {
        this.selectedMenus.second = item;
        if (item.route) {
          this.selectedMenus.third = undefined;
        }
      } else if (item.level == 3) {
        this.selectedMenus.third = item;
      }

      if (item.subMenus && item.subMenus.length) {
        if (item.level == 1) {
          this.drawers.second = !this.drawers.second;
        }
      } else {
        if (item.level == 1) {
          this.drawers.second = false;
        }
        this.goTo(item.route);
      }
    },
    goToHome() {
      this.$http.post(process.env.VUE_APP_URLAPIEXTERNAL, sessionStorage.getItem("supplierExtToken"))
        .then(
          function (result) {
            if (result.body.token != null) {
              sessionStorage.setItem("supplierExtToken", result.body.token)
            }
          }
        )
        .catch(
          function (result) {
            console.log("Invalid Token  for refresh time")
          }
        )
      this.selectedMenus.root = undefined;
      this.selectedMenus.second = undefined;
      this.selectedMenus.third = undefined;
      this.selectedMenus.currentRoute = undefined;
    },
    goToExternalPortal() {
      location.href = process.env.VUE_APP_URLEXTERNAL + "?token=" + sessionStorage.getItem("supplierExtToken")
    },
    getSubMenuItems(item) {
      if (!item || !item.subMenus) {
        return [];
      }
      return item.subMenus;
    },
    goTo(route) {
      this.selectedMenus.currentRoute = route;
      this.$router.push('/' + route);
      if (this.$router.currentRoute.name == route) {
        this.routerViewKey++;
      }
    },
    closeSesion: function (fullPath) {
      const allowDirectLogin = process.env.VUE_APP_ALLOW_DIRECT_LOGIN === 'true';

      if (allowDirectLogin) {
        localStorage.clear();
        sessionStorage.clear();
        events.$emit('closeSession');
        if (fullPath) {
          this.$router.push({ path: '/login', query: { redirect: fullPath } });
        } else {
          this.$router.push('/login');
        }
        return;
      }

      this.$http.post(process.env.VUE_APP_URLAPIEXTERNALLOGOUT, sessionStorage.getItem("supplierExtToken"))
        .then(
          function (result) {
            if (result.body.success == "OK") {
              localStorage.clear()
              sessionStorage.clear()
              events.$emit('closeSession')
              location.href = process.env.VUE_APP_URLLOGINEXTERNAL
            }
          }
        )
        .catch(
          function (error) {
            localStorage.clear()
            sessionStorage.clear()
            events.$emit('closeSession')
            location.href = process.env.VUE_APP_URLLOGINEXTERNAL
          }
        )
    },
    displayBadge: function (value) {
      if (value > 9) {
        return "+9"
      }
      return value;
    }
  },
  mounted() {
    /*Ask if route is fill and language is es-mx or en*/
    //FIXME: This is only for pre-prod/prod environments
    const allowDirectLogin = process.env.VUE_APP_ALLOW_DIRECT_LOGIN === 'true';
    if (process.env.NODE_ENV != 'development') {
      if (this.$route.query.token && (this.$route.query.lang == "es-mx" || this.$route.query.lang == "en")) {
        var login = { token: this.$route.query.token }
        localStorage.setItem("supplierToken", this.$route.query.token);
        /*Search if the token  is in the Database*/
        this.$http.get("TokenLogin/findExtToken" + "/" + this.$route.query.token).then(
          function (result) {
            sessionStorage.setItem("supplierExtToken", result.body.tokenExtPortal)
            var codeSupplier = {};
            codeSupplier.supplierCode = result.body.code;
            if (result != null) {
              /*Search who is the user which is accesing to the token*/
              this.$http.post("TokenLogin/findToken", login).then(
                function (result) {
                  if (result.status == 200) {
                    this.$http.post('SupplierLoginExternal/loginexternal', codeSupplier)
                      .then(response => {
                        this.supplierCode = response.body.supplierCode;
                        localStorage.setItem("supplierCode", response.body.supplierCode);
                        localStorage.setItem("supplierRFC", response.body.supplierRFC);
                        localStorage.setItem("supplierToken", response.body.token);
                        localStorage.setItem("supplierCredentials", response.body.credentials);
                      }).catch(error => {
                        this.closeSesion();
                      });
                  }
                  else {
                    location.href = process.env.VUE_APP_URLEXTERNAL
                  }
                },
                function (error) {
                  location.href = process.env.VUE_APP_URLEXTERNAL
                  localStorage.removeItem('supplierToken')
                  this.$router.replace({ 'query': null });
                }
              ).catch(error => {
                localStorage.removeItem('supplierToken')
              });
            }
          }
        ).catch(error => {
          localStorage.removeItem('supplierToken')
        });
        if (this.$route.query.lang == "en") {
          this.$set(i18n, 'locale', "en");
          this.updateMenuLanguage();
          events.$emit('updateLanguage');
        }
        this.$router.replace({ 'query': null });
      }
      else if (!allowDirectLogin) {
        location.href = process.env.VUE_APP_URLEXTERNAL
      }
    }

    var token = localStorage.getItem("supplierToken");
    if (!token) {
      this.$router.push('/login');
      return;
    }

    this.updateMenuLanguage();

    let iconPromises = this.items
      .filter(x => x.svg)
      .map(x =>
        this.$http.get(require(`../assets/${x.svg}`))
          .then(result => {
            this.icons[x.svg] = result.body;
          })
      );

    Promise.all(iconPromises).then(() => this.$forceUpdate());

    this.$http.get('app/getMySupplier')
      .then(response => {
        localStorage.setItem("supplierTemplate", response.body.template);
        this.supplier = response.body.supplier;
      }, error => {
        this.closeSesion();
      });

    this.checkMenusSelected();

    this.items.filter(x => !!x.showBadge).forEach(item => {
      if (!!item.badge.refreshFunction) {
        item.badge.refreshFunction(item.badge);
        if (!!item.badge.refreshTime) {
          this.badgeIntervals.push(setInterval(item.badge.refreshFunction.bind(this, item.badge), item.badge.refreshTime));
        }
      }
    });

    events.$on('closeSession', () => {
      this.badgeIntervals.forEach(intreval => {
        clearInterval(intreval);
      });
    });
  },
  computed: {
    imageSrc() {
      if (this.supplier && this.supplier.imageMIME && this.supplier.imageData) {
        return `data:${this.supplier.imageMIME};base64,${this.supplier.imageData}`;
      } else {
        return undefined
      }
    }
  }
}
</script>